import React from 'react'
import { Button } from 'semantic-ui-react'
import { useSelector } from 'react-redux'
import { selectHeaderTabDS } from '@EUForms/selectors'
import { useCurrentShipmentType } from '@hooks/useCurrentShipmentType'

const DMS_RFI = (props) => {
    const {
        shipId,
        shipmentMode,
        updateShipmentId,
        updateShipmentMode
    } = props

    const { isImportShipment } = useCurrentShipmentType()
    const { childShipments } = useSelector(selectHeaderTabDS)

    return (
        <div style={{ display: 'flex', justifyContent: 'flex-end', margin: '0px 10px' }}>
            <Button.Group className="esPscBtn">
                <Button
                    id='initialEntrySummary'
                    className={shipmentMode === 'ES' ? "selected" : ''}
                    onClick={() => {
                        updateShipmentId(shipId)
                        updateShipmentMode('ES')
                    }}
                >
                    INI
                </Button>
                <Button
                    id='rfiEntrySummary'
                    className={shipmentMode === 'RFI-1' ? "selected" : ''}
                    onClick={() => {
                        updateShipmentId(childShipments?.at(-1))
                        updateShipmentMode('RFI-1')
                    }}
                >
                    {isImportShipment ? 'CRI' : 'CRE'}
                </Button>
            </Button.Group>
        </div>
    )
}

export default DMS_RFI